module.exports = __webpack_public_path__ + "assets/img/elem3-ability2.3e97a81c.gif";